import {useEffect, useState} from "react";
import api from "../../../services/api";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {selectedColonicalBookId, selectedColonicalTableauId, selectedSchool} from "../../../recoils/recoil";
import {Link, useNavigate} from "react-router-dom";

const SchoolIdList = () => {
    const selectedSchoolList = useRecoilValue(selectedSchool);
    const setSelectedSchoolList = useSetRecoilState(selectedSchool);
    // 조선제학교 일람 setter
    const setSelectedColonicalBookId = useSetRecoilState(selectedColonicalBookId);
    // 조선제학교 일람 표 setter
    const setSelectedColonicalTableauId = useSetRecoilState(selectedColonicalTableauId);

    const [books, setBooks] = useState([]);
    const [psnorders, setPsnorders] = useState([]);
    const [tableaurecords, setTableaurecords] = useState([]);
    const [tableaux, setTableaux] = useState([]);
    const [tocrecords, setTocrecords] = useState([]);
    const [tocs, setTocs] = useState([]);
    const navigate = useNavigate();

    // const [firstSchoolName, setFirstSchoolName] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const getSchool = async () => {
            if (!selectedSchoolList || selectedSchoolList.length === 0) {
                return;
            }

            const schoolIdList = selectedSchoolList.map(school => school.id);

            try {
                setIsLoading(true);
                const response = await api.post('/get_data_by_school_ids', {
                    school_ids: schoolIdList
                });

                if (response.status === 200) {
                    const {books, psnorders, tableaurecords, tableaux, tocrecords, tocs} = response.data.data;

                    setBooks(books || []);
                    setPsnorders(psnorders || []);
                    setTableaurecords(tableaurecords || []);
                    setTableaux(tableaux || []);
                    setTocrecords(tocrecords || []);
                    setTocs(tocs || []);
                    // setFirstSchoolName(selectedSchoolList[0].name);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                setBooks([]);
                setPsnorders([]);
                setTableaurecords([]);
                setTableaux([]);
                setTocrecords([]);
                setTocs([]);
            } finally {
                setIsLoading(false);
            }
        };
        getSchool();
    }, [selectedSchoolList]);

    const handleDeleteSchool = (schoolId) => {
        if (selectedSchoolList.length === 1) {
            alert("최소 1개의 선택한 학교가 필요합니다.")
        } else {
            setSelectedSchoolList(prevData => prevData.filter(school => school.id !== schoolId));
        }
    }

    const backPage = () => {
        if (!selectedSchoolList || selectedSchoolList.length === 0) {
            console.error("선택된 학교가 없습니다.");
            return;
        }

        const schoolName = selectedSchoolList[0].name;

        if (!schoolName) {
            console.error("선택된 학교의 이름이 없습니다.");
            return;
        }

        const encodedName = encodeURIComponent(schoolName);
        navigate(`/school_search/${encodedName}`, {state: {isPersonBack: true}});
    };

    if (!selectedSchoolList || selectedSchoolList.length === 0) {
        return (
            <div className="container mx-4 my-6">
                <p className="text-gray-500">Please select a school to view their data.</p>
            </div>
        );
    }

    // 결과 없을 경우 랜더링
    const noResult = (
        <div className="list-row">
            <div className="list-empty">총 <span className="c-primary">0건</span>입니다.</div>
        </div>
    )

    // --------- 책 랜더링 분리 ---------
    let bookContent;

    if (books === null || books.length === 0) {
        bookContent = noResult;
    } else {
        bookContent = (
            books.map((book, index) => {
                const schoolIndex = selectedSchoolList.findIndex(school => school.id === book.school_id);
                return (
                    <div key={index} className="list-row">
                        <Link to={`/archive/${book.book_category}/${book.book_id}`} className="row-link">
                            <div className="num">{schoolIndex + 1}</div>

                            <div className="year">{book.publish_year || book.numeration || '-'}</div>
                            <div className="info-text">
                                <div className="main-text">
                                    {book.book_title_ko || book.book_title || '-'} {book.publisher || '-'}
                                </div>
                            </div>
                        </Link>
                    </div>
                );
            })
        );
    }

    // --------- 인사명령 랜더링 분리 ---------

    // 인사명령 팝업 띄우기
    const goToRedbookToc = (order) => {

        if (!order ) {
            console.error("인사명령 정보가 없습니다.");
            return;
        }

        navigate(`/archive/redbook/${order.book_id}`, {state: {order: order}});
    }

    let psnorderContent;

    if (psnorders === null || psnorders.length === 0) {
        // 책 없을 경우
        psnorderContent = noResult;
    } else {
        // 책 있을 경우
        psnorderContent = (
            psnorders.map((order, index) => {

                    // selectedPersonList에서 해당 book의 person_id와 일치하는 인물의 인덱스 찾기
                    const schoolIndex = selectedSchoolList.findIndex(school => school.id === order.school_id);

                    return (
                        <div key={index} className="list-row">
                            <Link to="#" className="row-link" onClick={(e) => {e.preventDefault(); goToRedbookToc(order)}}>
                                <div className="num">{schoolIndex + 1}</div>
                                <div className="year">{order.publish_year || '-'}</div>

                                <div className="info-text">
                                    <div className="year">{order.po_year || '-'}년</div>
                                    <div className="main-text"> {order.status_text || '-'}</div>
                                    <div className="year">{order.personname  || '-'}</div>
                                    <div className="year">{order.order_text  || '-'}</div>
                                    <div className="book">{order.book_title || '-'}</div>
                                    <div className="book">{order.numeration || '-'}</div>
                                    <div className="book">{order.publish_date || '-'}</div>
                                    <div className="toc">{order.toc_title || '-'}</div>
                                </div>
                            </Link>
                        </div>
                    )
                }
            )
        )
    }

    // --------- 목차 랜더링 분리 ---------
    let tocsContent;

    if (tocs === null || tocs.length === 0) {
        // 책 없을 경우
        tocsContent = noResult;
    } else {
        // 책 있을 경우
        tocsContent = (
            tocs.map((toc, index) => {

                    // selectedPersonList에서 해당 book의 person_id와 일치하는 인물의 인덱스 찾기
                    const schoolIndex = selectedSchoolList.findIndex(school => school.id === toc.school_id);

                    return (
                        <div key={index} className="list-row">
                            <Link to={`/archive/${toc.book_category}/${toc.book_id}`} className="row-link">
                                <div className="num">{schoolIndex + 1}</div>
                                <div className="year">{toc.numeration}</div>
                                <div className="info-text">
                                    <div
                                        className="main-text">{toc.toc_title_ko || toc.toc_title || '-'}
                                    </div>
                                    <div className="book">{toc.book_title}
                                    </div>
                                </div>
                            </Link>
                        </div>
                    )
                }
            )
        )
    }

    // --------- 목차 내용 랜더링 분리 ---------

    let tocrecordContnet;

    if (tocrecords === null || tocrecords.length === 0) {
        // 책 없을 경우
        tocrecordContnet = noResult;
    } else {
        // 책 있을 경우
        tocrecordContnet = (
            tocrecords.map((item, index) => {

                // selectedPersonList에서 해당 book의 person_id와 일치하는 인물의 인덱스 찾기
                const schoolIndex = selectedSchoolList.findIndex(school => school.id === item.school_id);

                return (
                    <div key={index} className="list-row">
                        <Link to={`/archive/biography/${item.book_id}`} className="row-link">
                            <div className="num">{schoolIndex + 1}</div>
                            <div className="year">{item.publish_year}</div>
                            <div className="info-text">
                                <div
                                    className="main-text">{item.record_text || '-'}</div>
                                <div
                                    className="book">{item.book_title}</div>
                                <div
                                    className="book">{item.toc_title || item.toc_title_ko || '-'}
                                </div>
                            </div>
                        </Link>
                    </div>
                )
            })
        )
    }

    // --------- 표 랜더링 분리 ---------

    let tableauxContent;

    // 이동
    const moveToIlamToc = (bookId) => {

        if (bookId) {

        setSelectedColonicalBookId(bookId);

        navigate("/archive/colonial_school")

        }


    }

    if (tableaux === null || tableaux.length === 0) {
        // 책 없을 경우
        tableauxContent = noResult;
    } else {
        // 책 있을 경우
        tableauxContent = (
            tableaux.map((item, index) => {

                // selectedPersonList에서 해당 book의 person_id와 일치하는 인물의 인덱스 찾기
                const schoolIndex = selectedSchoolList.findIndex(school => school.id === item.person_id);

                return (
                    <div key={index} className="list-row">
                        <Link to="#" className="row-link" onClick={(e) =>
                        {e.preventDefault(); moveToIlamToc(item.book_id)}}>
                            <div className="num">{schoolIndex + 1}</div>
                            <div className="year">{item.publish_year}</div>
                            <div className="info-text">
                                <div
                                    className="main-text">{item.tableaux_title || '-'}</div>
                                <div
                                    className="book">{item.book_title}</div>
                            </div>
                        </Link>
                    </div>
                )
            })
        )
    }

    // --------- 표 내용 랜더링 분리 ---------
    let tableaurecordContent;

    // 이동
    const moveToTableau = (bookId, tableauId) => {

        if (bookId && tableauId) {

        setSelectedColonicalBookId(bookId);
        setSelectedColonicalTableauId(tableauId);
        navigate("/archive/colonial_school")

        }

    }

    if (tableaurecords === null || tableaurecords.length === 0) {
        tableaurecordContent = noResult;
    } else {
        tableaurecordContent = (
            tableaurecords.map((record, index) => {
                const schoolIndex = selectedSchoolList.findIndex(school => school.id === record.school_id);
                const recordData = JSON.parse(record.record_text_ko || '{}');

                return (
                    <div key={index} className="list-row">
                        <Link to="#" className="row-link" onClick={(e) =>
                        {e.preventDefault(); moveToTableau(record.book_id, record.tableau_id)}} >
                            <div className="num">{schoolIndex + 1}</div>
                            <div className="info-text">
                                <div className="main-text"><span
                                    className="bold">{record.primaryname_ko || record.primaryname || '학교명 없음'}</span>
                                    <span className="location">소재지: {recordData['소재지'] || '-'}</span>
                                    <span className="creation">창립: {recordData['창립년월'] || '-'}</span>
                                    <span className="duration">수업연한: {recordData['수업연한'] || '-'}</span>
                                    <span className="classes">학급수: {recordData['학급수'] || '-'}</span>
                                    <span
                                        className="staff">직원수 (내지인/조선인): {recordData['직원수_내지인'] || '-'} / {recordData['직원수_조선인'] || '-'}</span>
                                    <span className="students">학생수 (총계): {recordData['생도수_계'] || '-'}</span>

                                    <span
                                        className="budget">경상/임시 예산 (円): {recordData['경비_경상부 (円)'] || '-'} / {recordData['경비_임시부 (円)'] || '-'}</span>
                                    <span
                                        className="total-budget">총 예산 (円): {recordData['경비_계 (円)'] || '-'}</span>
                                </div>
                                <div className="book">{record.book_title}</div>
                                <div className="toc">{record.toc_title}</div>
                                <div className="table">
                                    {record.tableau_title}
                                </div>

                            </div>
                        </Link>
                    </div>
                );
            })
        );
    }

    return (
        <main id="contents">
            <div className="sub-content">
                <div className="search-wrap">
                    <div className="cont-top">
                        <div className="w-set">
                            <div className="title-wrap">
                                <h2 className="title batang">공간</h2>
                                <p className="text">조선제학교일람을 통해 <br/>일제강점기 조선총독부가 조선의 교육 상황을 기록한 자료를 확인 할 수 있습니다.</p>
                            </div>
                        </div>
                    </div>
                    <div className="cont-btm">
                        <div className="w-set">
                            <div className="search-list-wrap">
                                <div className="search-btm">
                                    <form action="">
                                        <div className="filter-wrap">
                                            <div className="filter-left">
                                                <div className="total-wrap">
                                                    <p>선택한 학교 총 <span>{selectedSchoolList.length}개</span></p>
                                                </div>
                                                <div className="name-wrap">
                                                    <ul className="name-list">
                                                        {selectedSchoolList.map((school, index) => (
                                                            <li key={school.id}>
                                                                <span className="num">{index + 1}</span>
                                                                <p className="name">{school.name}</p>
                                                                <button
                                                                    type="button"
                                                                    className="btn-delete"
                                                                    onClick={() => handleDeleteSchool(school.id)}
                                                                >
                                                                    삭제
                                                                </button>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                    <div className="btn-wrap">
                                                        <Link to="#" className="btn" onClick={(e) => {
                                                            e.preventDefault();
                                                            backPage();
                                                        }}>
                                                            <i className="i-add"></i>학교 추가 검색
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>

                                            {/*----------검색 결과----------*/}
                                            <div className="filter-right">
                                                <div className="result-wrap">

                                                    <div className="section-wrap">
                                                        {/* 책 */}
                                                        <div className="section-title"><p>책</p></div>
                                                        <div className="table-wrap view-table">
                                                            {bookContent}
                                                        </div>
                                                    </div>

                                                    {/* 인사명령 */}
                                                    <div className="section-wrap">
                                                        <div className="section-title"><p>인사명령</p></div>
                                                        <div className="table-wrap view-table">
                                                            {psnorderContent}
                                                        </div>
                                                    </div>

                                                    {/* 목차 */}
                                                    <div className="section-wrap">
                                                        <div className="section-title"><p>목차</p></div>
                                                        <div className="table-wrap view-table">
                                                            {tocsContent}
                                                        </div>
                                                    </div>

                                                    {/* 내용 */}
                                                    <div className="section-wrap">
                                                        <div className="section-title"><p>내용</p></div>
                                                        <div className="table-wrap view-table">
                                                            {tocrecordContnet}
                                                        </div>
                                                    </div>

                                                    {/* 표 */}
                                                    <div className="section-wrap">
                                                        <div className="section-title"><p>표</p></div>
                                                        <div className="table-wrap view-table">
                                                            {tableauxContent}
                                                        </div>
                                                    </div>

                                                    {/* 표 내용*/}
                                                    <div className="section-wrap">
                                                        <div className="section-title"><p>표 내용</p></div>
                                                        <div className="table-wrap view-table">
                                                            {tableaurecordContent}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/*로딩 인디케이터*/}
                                                <div className="load-wrap"
                                                     style={{display: isLoading ? 'block' : 'none'}}>
                                                    <div className="load-box">
                                                        <div className="square"></div>
                                                        <div className="square"></div>
                                                        <div className="square"></div>
                                                        <div className="square"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default SchoolIdList;